import { atom } from "recoil";

export const parametersState = atom({
  key: "parametersState",
  default: [],
});
